
import { defineComponent, ref, reactive, toRefs, onMounted, watch, watchEffect, nextTick, computed } from 'vue'
import { DoubleRightOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import api from '@/api/allApi'
import { init, ECharts, EChartsOption } from 'echarts'
import Table from '@/components/table.vue'
import Charts from '@/components/page/charts.vue'
import globalsets from '@/utils/globalsets'
import Nodata from '@/components/page/nodata.vue'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    title: {
      type: String,
      default: () => {
        return ''
      }
    },
    visible: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    width: {
      type: [String, Number],
      default: () => {
        return '' || 0
      }
    },
    mask: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    bodyStyle: {
      type: Object,
      default: () => {
        return {}
      }
    },
    drawerStyle: {
      type: Object,
      default: () => {
        return {}
      }
    },
    currentshareholder: {
      type: Object,
      default: () => {
        return {}
      }
    },
    getContainer: [Function, Boolean],
    tableData: {
      type: Array,
      default: () => {
        return []
      }
    },
    columns: {
      type: Array,
      default: () => {
        return []
      }
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    currentsharesName: {
      type: String,
      default: () => {
        return ''
      }
    },
    wrapClassName: {
      type: String,
      default: () => {
        return ''
      }
    },
    total2: {
      type: Number,
      default: () => {
        return 0
      }
    }
  },
  components: { Table, Nodata, Charts },
  setup(props, context) {
    const pageData: any = reactive({
      visible1: props.visible,
      key: new Date().getTime() + '',
      getContainer: () => document.querySelector('.f10wrapper .f10'),
      showf10drawer: false,
      name: props.currentsharesName,
      pagination2: {}
    })
    pageData.pagination2 = computed(() => {
      return {
        total: props.total2,
        // simple: true,
        showSizeChanger: true,
        showTotal: (total: any) => `共${props.total2}条`,
        pageSizeOptions: ['10', '20', '50', '100'],
        onChange: changesize,
        onShowSizeChange: changesize
      }
    })
    function changesize(PageID: any, PageSize: any) {
      context.emit('changesize', { PageID, PageSize })
    }
    watch(
      () => props.currentsharesName,
      (val: any) => {
        nextTick(() => {
          pageData.name = val
        })
      },
      { deep: true, immediate: true }
    )
    watch(
      () => props.tableData,
      (val: any) => {
        nextTick(() => {
          let dom: any = {}
          if (props.title === 'sdltgddrawer') {
            dom = document.querySelector('.sdgdwrap .ant-drawer-content-wrapper')
          } else {
            dom = document.querySelector('.sdltgdwrap .ant-drawer-content-wrapper')
          }
          if (dom) {
            dom.style.transform = 'translateX(100%)'
          }
        })
      },
      { deep: true, immediate: true }
    )
    return {
      ...toRefs(pageData)
    }
  }
})
